module.exports = __webpack_public_path__ + "static/media/BariolLight-Italic.ee497b76.woff";